import React from 'react'
import PageHeader from '../../componentsII/PageHeader';
import api from '../../axios/api';
import { TableContainer, TableBody, TableCell, TableHead, TablePagination, TableRow, Table, Paper, Switch, IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import { useEffect, useState } from 'react';
import { X, Trash2 as DeleteIcon, PenBoxIcon, PlusIcon } from 'lucide-react';
import { format, set } from "date-fns";
import CustomButton from '../../componentsII/Buttons';
import { useDispatch } from 'react-redux';
import { showNotification } from '../../redux/slices/notificationSlice';
import AddUpdateVehicleSubTypeModal from '../../components/Masters/VehicleSubTypeMaster/AddUpdateVehicleSubTypeModal';
import { TextField, FormControl, InputLabel, Select, MenuItem, TableFooter } from '@mui/material';
import debounce from 'lodash/debounce';
import { Search } from 'lucide-react';

const VehicleSubTypeMaster = () => {
  const [vehicleSubTypes, setVehicleSubTypes] = useState([]);
  const dispatch = useDispatch();

  const [isAddUpdateVehicleSubTypeModalOpen, setIsAddUpdateVehicleSubTypeModalOpen] = useState(false);
  const [selectedVehicleSubType, setSelectedVehicleSubType] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [vehicleSubTypeToDelete, setVehicleSubTypeToDelete] = useState(null);

  const [totalVehicleSubTypes, setTotalVehicleSubTypes] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filters, setFilters] = useState({
    search: '',
    status: 'ALL',
    sortBy: 'vs.created_at',
    sortOrder: 'desc'
  });

  const getVehicleSubTypes = async (pageNumber = page, limit = rowsPerPage, filterParams = filters) => {
    try {
      const response = await api.get('/admin/getVehicleSubType', {
        params: {
          page: pageNumber + 1,
          limit,
          search: filterParams.search,
          status: filterParams.status === 'ALL' ? '' : filterParams.status,
          sortBy: filterParams.sortBy,
          sortOrder: filterParams.sortOrder
        }
      });
      setVehicleSubTypes(response.data.data);
      setTotalVehicleSubTypes(response.data.total );
    } catch (error) {
      dispatch(showNotification({
        message: 'Failed to fetch vehicle sub types',
        type: 'error',
      }));
    }
  }

  useEffect(() => {
    getVehicleSubTypes();
  }, [page, rowsPerPage, filters]);

  const debouncedSearch = debounce((value) => { setFilters(prev => ({ ...prev, search: value })); setPage(0); }, 500);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleRemove = async (id) => {
    const vehicleTypeDel = vehicleSubTypes.find(type => type.id === id);
    setVehicleSubTypeToDelete(vehicleTypeDel);
    setDeleteDialogOpen(true);
  }

  const confirmDelete = async () => {
    try {
      setIsSubmitting(true);
      const response = await api.delete(`/admin/deleteVehicleSubType/${vehicleSubTypeToDelete.id}`);
      if (response.data.status == 200) {
        dispatch(showNotification({
          message: 'Vehicle Sub Type deleted successfully',
          type: "success"
        }));
        getVehicleSubTypes();
      } else {
        dispatch(showNotification({
          message: 'Failed to delete Vehicle Type',
          type: "error"
        }));
      }
    } catch (error) {
      console.error('Error deleting Vehicle Type', error);
      dispatch(showNotification({
        message: 'An error occurred while deleting',
        type: "error"
      }));
    } finally {
      setIsSubmitting(false);
      setDeleteDialogOpen(false);
      setVehicleSubTypeToDelete(null);
    }
  }

  const ActivateDeactivate = async (user) => {
    try {
      setIsSubmitting(true);
      const response = await api.post(`/admin/activateDeactivateVehicleSubType/${user.id}`, {
        is_active: user.is_active == "1" ? 0 : 1
      });
      if (response.data.status == 200) {
        dispatch(showNotification({
          message: user.is_active ? 'Vehicle Sub Type deactivated successfully' : 'Vehicle Sub Type activated successfully',
          type: "success"
        }));
        getVehicleSubTypes();
      } else {
        dispatch(showNotification({
          message: user.is_active ? 'Failed to deactivate vehicle type' : 'Failed to activate vehicle type',
          type: "error"
        }));
      }
    } catch (error) {
      console.error('Error activating/deactivating vehicle type:', error);
      dispatch(showNotification({
        message: 'An error occurred',
        type: "error"
      }));
    } finally {
      setIsSubmitting(false);
    }
  }

  const handleEdit = async (user) => {
    setSelectedVehicleSubType(user);
    setIsAddUpdateVehicleSubTypeModalOpen(true);
  }

  return (
    <>
      <PageHeader title="Vehicle Subtypes">
        <div className="flex justify-end gap-5 items-center mt-5">
          <div className="flex items-center gap-4 flex-1">
            {/* Search Field */}
            <TextField
              size="small"
              placeholder="Search vehicle sub types..."
              InputProps={{
                startAdornment: <Search className="w-5 h-5 text-gray-500 mr-2" />,
              }}
              onChange={(e) => debouncedSearch(e.target.value)}
              className="min-w-[300px]"
            />

            {/* Status Filter */}
            <FormControl size="small" className="min-w-[150px]">
              <InputLabel>Status</InputLabel>
              <Select
                value={filters.status}
                label="Status"
                onChange={(e) => {
                  setPage(0);
                  setFilters(prev => ({ ...prev, status: e.target.value }))
                }}
              >
                <MenuItem value="ALL">All</MenuItem>
                <MenuItem value="ACTIVE">ACTIVE</MenuItem>
                <MenuItem value="INACTIVE">INACTIVE</MenuItem>
              </Select>
            </FormControl>

            {/* Sort By */}
            <FormControl size="small" className="min-w-[150px]">
              <InputLabel>Sort By</InputLabel>
              <Select
                value={filters.sortBy}
                label="Sort By"
                onChange={(e) =>{
                  setPage(0);
                  setFilters(prev => ({ ...prev, sortBy: e.target.value }))
                }}
              >
                <MenuItem value="vs.created_at">Created Date</MenuItem>
               <MenuItem value="vt.type_name">Type Name</MenuItem>
               <MenuItem value="vs.sub_type_name">Vehicle Sub Type Name</MenuItem>
              </Select>
            </FormControl>

            {/* Sort Order */}
            <FormControl size="small" className="min-w-[150px]">
              <InputLabel>Order</InputLabel>
              <Select
                value={filters.sortOrder}
                label="Order"
                onChange={(e) => {
                  setPage(0);
                  setFilters(prev => ({ ...prev, sortOrder: e.target.value }))
                }}
              >
                <MenuItem value="asc">Ascending</MenuItem>
                <MenuItem value="desc">Descending</MenuItem>
              </Select>
            </FormControl>
          </div>
          <CustomButton
            tooltip='Add Vehicle Sub Type'
            className="bg-green-600 hover:bg-green-700 text-white"
            text={<><PlusIcon /> Add Vehicle Sub Type</>}
            click={() => setIsAddUpdateVehicleSubTypeModalOpen(true)}
          />
        </div>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Vehicle Type Name</TableCell>
                <TableCell>Vehicle Sub Type Name</TableCell>
                <TableCell>Is Active</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {vehicleSubTypes?.map((user) => (
                <TableRow key={user.id}>
                  <TableCell>{user.type_name}</TableCell>
                  <TableCell>{user.sub_type_name}</TableCell>
                  <TableCell>
                    <Switch
                      checked={user.is_active == "1" ? 1 : user.is_active == "0" ? 0 : null}
                      color='success'
                      onChange={(e) => ActivateDeactivate(user)}
                      disabled={isSubmitting}
                    />
                  </TableCell>
                  <TableCell>
                    {user.created_date ? format(new Date(user.created_date), "dd-MM-yyyy") : ""}
                  </TableCell>
                  <TableCell sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <IconButton
                      size="small"
                      onClick={() => handleEdit(user)}
                      sx={{
                        backgroundColor: '#16A34A',
                        color: 'white',
                        '&:hover': { backgroundColor: '#00bf46' },
                        p: '8px',
                      }}
                    >
                      <PenBoxIcon size={20} />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleRemove(user.id)}
                      sx={{
                        backgroundColor: '#df3e3e',
                        color: 'white',
                        '&:hover': { backgroundColor: '#ff0000' },
                        p: '8px',
                      }}
                    >
                      <DeleteIcon size={20} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  colSpan={7}
                  count={totalVehicleSubTypes}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  labelDisplayedRows={({ from, to, count }) => 
                    `Page ${page + 1} of ${Math.ceil(count / rowsPerPage)} | ${from}-${to} of ${count}`
                  }
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>

        <Dialog
          open={isAddUpdateVehicleSubTypeModalOpen}
          onClose={() => { setIsAddUpdateVehicleSubTypeModalOpen(false); setSelectedVehicleSubType(null) }}
          maxWidth="sm"
          fullWidth
        >
          <div className="flex justify-between items-start pt-2 px-2">
            <DialogTitle className="text-lg font-bold mt-1">
              {selectedVehicleSubType ? "Edit Vehicle SubType" : "Add New Vehicle SubType"}
            </DialogTitle>
            <X
              className="w-6 h-6 cursor-pointer text-gray-500 hover:text-gray-700 transition"
              onClick={() => { setIsAddUpdateVehicleSubTypeModalOpen(false); setSelectedVehicleSubType(null) }}
            />
          </div>
          <DialogContent >
            <AddUpdateVehicleSubTypeModal
              refetch={getVehicleSubTypes}
              onClose={() => {
                setIsAddUpdateVehicleSubTypeModalOpen(false);
                setSelectedVehicleSubType(null);
              }}
              vehicleSubTypeId={selectedVehicleSubType?.id}
              initialData={selectedVehicleSubType}
            />
          </DialogContent>
        </Dialog>

        <Dialog
          open={deleteDialogOpen}
          onClose={() => setDeleteDialogOpen(false)}
        >
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete the equipment type "{vehicleSubTypeToDelete?.type_name}"? This action cannot be undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <div className="flex justify-end gap-5 items-center mt-5">
              <CustomButton
                className="bg-gray-500 hover:bg-gray-700 text-white"
                text="Cancel"
                disabled={isSubmitting}
                click={() => setDeleteDialogOpen(false)}
              />
              <CustomButton
                className="bg-red-600 hover:bg-red-700 text-white"
                click={confirmDelete}
                text='Delete'
                disabled={isSubmitting}
              />
            </div>
          </DialogActions>
        </Dialog>

      </PageHeader>
    </>
  )
}

export default VehicleSubTypeMaster